/* eslint-disable react-hooks/rules-of-hooks */
import React from "react";
import {
  Button,
  Checkbox,
  FormControl,
  IconButton,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import RateShopAccordion from "./RateShopAccordion";
import { Close } from "@mui/icons-material";

const MAX_DAYS_CHECK = 90;

const rateshopType = ["Rateshop", "Rate Parity"];

const RateshopScheduling = ({
  guests,
  nights,
  allSources,
  newRateShop,
  rateShopNames,
  handleChange,
  handleCreateNewRateshop,
  handleChangeNewRateshopDetails,
  handleSaveRateShop,
  isRateShopLoading,
  isScheduleLoading,
  isAddingRateShop,
  setSchedulingName,
  formEdit,
  setformEdit,
  week,
  handleSaveScheduling,
  scheduleError,
  schedulingName,
  handleDeleteScheduling,
  handleDeleteNewSchedule,
  handleDeleteRateShop,
  handleAddScheduling,
  showAddNewRateShop,
  setShowAddNewRateShop,
  platforms,
  editSchedulingEnable,
  setEditSchedulingEnable,
  handleUpdateScheduling, 
  setScheduleError
}) => {
  const isNewRateShopValid = () => {
    if (
      !newRateShop?.name ||
      !newRateShop?.occupancy ||
      !newRateShop?.los ||
      (newRateShop?.hotelOnly && !newRateShop?.platform) ||
      !newRateShop?.days ||
      newRateShop?.days > MAX_DAYS_CHECK ||
      !newRateShop?.sources?.length
    ) {
      return false;
    }
    return true;
  };

  return (
    <RateshopSchedulingWrapper>
      <Stack className="header">
        <Typography className="header-text">Rateshop Scheduling</Typography>
        <Button variant="contained" onClick={() => setShowAddNewRateShop(true)}>
          + Add Rateshop
        </Button>
      </Stack>

      {showAddNewRateShop && (
        <Stack className="rateshop-add-section">
          <Stack className="new-rateshop">
            <TextField
              fullWidth
              label="Name"
              placeholder="Enter Rate Shop Name"
              value={newRateShop?.name}
              onChange={(e) => handleChangeNewRateshopDetails(e, "name")}
              error={!newRateShop?.name}
              sx={{ width: "16%" }}
            />

            <FormControl sx={{ width: "16%" }}>
              <InputLabel
                id={"label-type"}
                error={newRateShop?.hotelOnly == null}
              >
                Type
              </InputLabel>
              <Select
                labelId="label-type"
                value={newRateShop?.hotelOnly ? "Rate Parity" : "Rateshop"}
                onChange={(e) => handleChangeNewRateshopDetails(e, "type")}
                error={newRateShop?.hotelOnly == null}
                input={<OutlinedInput label="type" />}
                renderValue={(selected) => selected}
              >
                {rateshopType.map((type) => (
                  <MenuItem key={type} value={type}>
                    <ListItemText primary={type} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl sx={{ width: "16%" }}>
              <InputLabel id={"label-guest"} error={!newRateShop?.occupancy}>
                Guest
              </InputLabel>
              <Select
                labelId="label-guest"
                value={newRateShop?.occupancy}
                onChange={(e) => handleChangeNewRateshopDetails(e, "occupancy")}
                error={!newRateShop?.occupancy}
                input={<OutlinedInput label="Guest" />}
                renderValue={(selected) => selected}
              >
                {guests.map((guest) => (
                  <MenuItem key={guest} value={guest}>
                    <ListItemText primary={guest} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ width: "16%" }}>
              <InputLabel id={"label-los"} error={!newRateShop?.los}>
                LOS
              </InputLabel>
              <Select
                labelId="label-los"
                value={newRateShop?.los}
                onChange={(e) => handleChangeNewRateshopDetails(e, "los")}
                error={!newRateShop?.los}
                input={<OutlinedInput label="LOS" />}
                renderValue={(selected) => selected}
              >
                {nights.map((night) => (
                  <MenuItem key={night} value={night}>
                    <ListItemText primary={night} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {newRateShop?.hotelOnly && (
              <FormControl sx={{ width: "16%" }}>
                <InputLabel
                  id={"label-platform"}
                  error={!newRateShop?.platform}
                >
                  Platform Type
                </InputLabel>
                <Select
                  labelId="label-platform"
                  value={newRateShop?.platform}
                  onChange={(e) =>
                    handleChangeNewRateshopDetails(e, "platform")
                  }
                  error={!newRateShop?.platform}
                  input={<OutlinedInput label="Platform Type" />}
                  renderValue={(selected) => selected}
                >
                  {platforms.map((item) => (
                    <MenuItem key={item} value={item}>
                      <ListItemText primary={item} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}

            <TextField
              label="No. Of Days"
              type="number"
              value={newRateShop?.days}
              error={!newRateShop?.days || newRateShop?.days > MAX_DAYS_CHECK}
              helperText={
                newRateShop?.days > MAX_DAYS_CHECK
                  ? `No. Of Days should be upto ${MAX_DAYS_CHECK}`
                  : ""
              }
              onChange={(e) => {
                handleChangeNewRateshopDetails(e, "days");
              }}
              sx={{ width: "16%" }}
            />
            <FormControl sx={{ width: "16%" }}>
              <InputLabel
                id={"label-ota"}
                error={!newRateShop?.sources?.length > 0}
              >
                OTA
              </InputLabel>
              <Select
                labelId="label-ota"
                multiple={newRateShop?.hotelOnly}
                value={
                  newRateShop?.hotelOnly
                    ? newRateShop?.sources?.map((src) => src.id) || []
                    : newRateShop?.sources?.[0]?.id || ""
                }
                error={!newRateShop?.sources?.length > 0}
                onChange={(e) => handleChangeNewRateshopDetails(e, "sources")}
                input={<OutlinedInput label="OTA" />}
                renderValue={(selected) =>
                  newRateShop?.hotelOnly
                    ? allSources
                        .filter((s) => selected.includes(s.id))
                        .map((s) =>
                          s.isMobile
                            ? `${s.name} (Mobile)`
                            : `${s.name} (Desktop)`
                        )
                        .join(", ")
                    : allSources
                        .filter((s) => selected === s.id)
                        .map((s) =>
                          s.isMobile
                            ? `${s.name} (Mobile)`
                            : `${s.name} (Desktop)`
                        )
                        .join(",")
                }
              >
                {(() => {
                  const selectedSourceIds = React.useMemo(
                    () => new Set(newRateShop?.sources?.map((s) => s.id) ?? []),
                    [newRateShop?.sources]
                  );

                  return allSources
                    .filter((source) => {
                      // First: Apply hotelOnly filtering for non-brand websites
                      if (!newRateShop?.hotelOnly) {
                        return !source.isBrandWebsite;
                      }

                      // Second: For hotelOnly, always include brand websites
                      if (source.isBrandWebsite) {
                        return true;
                      }

                      // Third: For hotelOnly, filter other sources based on platform
                      if (newRateShop?.platform === "Desktop") {
                        return !source.isMobile;
                      }
                      if (newRateShop?.platform === "Mobile") {
                        return source.isMobile;
                      }

                      // If no platform is selected, include all other sources.
                      return true;
                    })
                    .map((source) => (
                      <MenuItem key={source?.id} value={source?.id}>
                        {newRateShop?.hotelOnly && (
                          <Checkbox
                            checked={selectedSourceIds.has(source.id)}
                          />
                        )}
                        <ListItemText
                          primary={
                            source?.isMobile
                              ? `${source?.name} (Mobile)`
                              : `${source?.name} (Desktop)`
                          }
                        />
                      </MenuItem>
                    ));
                })()}
              </Select>
            </FormControl>

            <LoadingButton
              variant="contained"
              sx={{ height: "40px", width: "90px" }}
              loading={isAddingRateShop}
              disabled={isAddingRateShop || !isNewRateShopValid()}
              onClick={handleCreateNewRateshop}
            >
              Save
            </LoadingButton>
            <IconButton onClick={() => setShowAddNewRateShop(false)}>
              <Close />
            </IconButton>
          </Stack>
        </Stack>
      )}

      <Stack gap={2}>
        {rateShopNames.map((item, index) => (
          <RateShopAccordion
            key={item.rateShopId || `RateShop-Accordion-${index}`}
            item={item}
            index={index}
            guests={guests}
            nights={nights}
            rateshopType={rateshopType}
            allSources={allSources}
            handleChange={handleChange}
            handleSaveRateShop={handleSaveRateShop}
            isRateShopLoading={isRateShopLoading}
            isLoading={isScheduleLoading}
            setSchedulingName={setSchedulingName}
            formEdit={formEdit}
            setformEdit={setformEdit}
            week={week}
            handleSaveScheduling={handleSaveScheduling}
            scheduleError={scheduleError}
            schedulingName={schedulingName}
            handleDeleteScheduling={handleDeleteScheduling}
            handleDeleteNewSchedule={handleDeleteNewSchedule}
            handleDeleteRateShop={handleDeleteRateShop}
            handleAddScheduling={handleAddScheduling}
            platforms={platforms}
            editSchedulingEnable={editSchedulingEnable}
            setEditSchedulingEnable={setEditSchedulingEnable}
            handleUpdateScheduling={handleUpdateScheduling}
            setScheduleError={setScheduleError}
          />
        ))}
      </Stack>
    </RateshopSchedulingWrapper>
  );
};

export default RateshopScheduling;

const RateshopSchedulingWrapper = styled(Stack)(() => ({
  ".header": {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "20px",
  },
  ".header-text": {
    fontSize: "16px",
    fontWeight: "600",
  },
  ".rateshop-add-section": {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    backgroundColor: "#F8FAFC4D",
    border: "1px solid #E2E8F0",
    padding: "20px",
    borderRadius: "6px",
    marginBottom: "20px",
  },
  ".new-rateshop": {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: "20px",
  },

  ".borderStack": {
    gap: "16px",
    padding: "24px",
    boxShadow: "1px 4px 10px rgba(48, 111, 188, 0.2)",
  },
  ".accordionStack": {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    padding: "5vh 5vw",
    maxHeight: "60vh",
    overflowY: "auto",
    overflowX: "hidden",
    border: "1px solid #ccc",
    borderRadius: "8px",
  },
}));
